const CONSOLE_PREFIX = '/console';

// Params
const APPLICATION_ID_PARAM = 'appId';
const ACCOUNT_ID_PARAM = 'accountId';
const ORGANIZATION_ID_PARAM = 'organizationId';

// Helper routes
const APPLICATION_DETAIL_ROUTE = `${CONSOLE_PREFIX}/application/`;
const ACCOUNT_DETAIL_ROUTE = `${CONSOLE_PREFIX}/account/`;
const ANALYTICS_ROUTE = `${CONSOLE_PREFIX}/analytics/`;

// Routes
const ROUTES = {
    BASE: `${CONSOLE_PREFIX}/`,
    DASHBOARD: `${CONSOLE_PREFIX}/dashboard`,
    LOGIN: `${CONSOLE_PREFIX}/login`,
    PROFILE: `${CONSOLE_PREFIX}/profile`,
    APPLICATIONS: `${CONSOLE_PREFIX}/applications`,
    ANALYTICS: `${ANALYTICS_ROUTE}:${ORGANIZATION_ID_PARAM}`,
    AUDIT_GLOBAL: `${CONSOLE_PREFIX}/audit`,
    APPLICATION_DETAIL: `${APPLICATION_DETAIL_ROUTE}:${APPLICATION_ID_PARAM}`,
    ACCOUNTS: `${CONSOLE_PREFIX}/accounts`,
    ACCOUNT_DETAIL: `${ACCOUNT_DETAIL_ROUTE}:${ACCOUNT_ID_PARAM}`,
    NOTIFICATIONS: `${ACCOUNT_DETAIL_ROUTE}:${ACCOUNT_ID_PARAM}/notifications`,
    GUIDES_LIST: `${CONSOLE_PREFIX}/application/${APPLICATION_ID_PARAM}/guides`,
    GUIDES: '/guides',
    CONTEXT_HELP: '/context-help',
    JOURNEYS: '/journey',
    SEGMENTS: '/segments',
    AUDIENCE: '/audience',
    THEMES: '/themes',
    SETTINGS: '/settings',
    SETTINGS_GENERAL: '/general',
    SETTINGS_INTEGRATION: '/integration',
    SETTINGS_LANGUAGE: '/language',
    SETTINGS_IDENTITY: '/identity',
    SETTINGS_MULTITENANCY: '/multitenancy',
    SETTINGS_TRACKING: '/tracking',
    SETTINGS_CONFUSION: '/confusion',
    SETTINGS_GUIDE_DEFAULTS: '/guide-defaults',
    SETTINGS_ACCESS: '/access',
    SETTINGS_SECURITY: '/security',
    SETTINGS_SELECTOR_SYSTEM: '/selector-system',
    SETTINGS_SELECTOR_DEFAULTS: '/selector-defaults',
    SETTINGS_PASSWORD: '/password',
    SETTINGS_THEME: '/theme',
    SETTINGS_BILLING: '/billing',
    SETTINGS_INVOICES: '/invoices',
    SETTINGS_ADD_ONS: '/add-ons',
    SETTINGS_AUDIENCE: '/audience',
    SETTINGS_BILLING_UPDATE: '/billing-update',
    CREATE_SUBSCRIPTION: '/create-subscription',
    CONTEXT_HELP_COMPOSITION: '/composition',
    CONTEXT_HELP_SETTINGS: '/settings',
};

export {
    ROUTES,
    CONSOLE_PREFIX,
    APPLICATION_ID_PARAM,
    APPLICATION_DETAIL_ROUTE,
    ACCOUNT_DETAIL_ROUTE,
    ANALYTICS_ROUTE,
};
